import React from 'react'

// ** Global dependencies
import useClickOutside from '../../core/hooks/useClickOutside'
import HintBox from '../../components/common/HintBox'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import { formatNumber, stringToNumber, deformatNumber } from '../../core/utils/common'
import { getMainTheme } from '../../core/utils/theme'
import { useMainContext } from '../../core/contexts/main'
import Text from '../../core/utils/Text'
import { useCopyToClipboard } from '../../pages/wallet/utils/useCopyToClipboard'
import CustomTab from '../../components/layouts/Tab/CustomTab'
import { TABLET_SIZE } from '../../core/constants/common'
import { ReactComponent as StakingIcon } from '../../components/common/icons/piggy.svg'
import { FaHistory } from 'react-icons/fa'
import { FaArrowLeftLong } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

const CreateStaking = React.lazy(() => import('./components/CreateStaking'))
const StakingHistory = React.lazy(() => import('./components/StakingHistory'))
const MainLayout = React.lazy(() => import('../../components/layouts/NewLayout'))
const CardLayout = React.lazy(() => import('../../components/layouts/CardLayout'))
const MobileModal = React.lazy(() => import('../../components/modals/MobileModal'))
const ModalLayout = React.lazy(() => import('../../components/layouts/ModalLayout'))

const tabs = [
  {
    label: 'new-staking',
    content: <CreateStaking />,
    url: '/staking',
    respLink: '/rstaking',
    icon: <StakingIcon className={'text-active'} />,
  },
  {
    label: 'staking-history',
    content: <StakingHistory />, // Placeholder for My Contacts content
    url: '/staking-history',
    respLink: '/rstaking-history',
    icon: (
      <div className={'mx-2 text-active'}>
        <FaHistory size={22} />
      </div>
    ),
  },
]

const StakingDashboard = () => {
  const { width } = useWindowSize()
  const {
    main: { lang },
  } = useMainContext()

  return (
    <MainLayout className={'relative'}>
      {width > TABLET_SIZE ? (
        <CustomTab tabs={tabs} useRouting />
      ) : (
        <div className={'flex flex-col gap-3 p-3'}>
          {tabs.map((tab) => {
            return (
              <Link to={tab.respLink} key={tab.label}>
                <div
                  className={
                    'text-sm font-semibold dark:text-slate-100 max-h-[64px] rounded-md bg-slate-200 dark:bg-secondaryBg p-5 flex items-center justify-between'
                  }
                >
                  <div className={'flex items-center gap-2'}>
                    {tab.icon}
                    <Text tid={tab.label} />
                  </div>
                  <FaArrowLeftLong
                    size={20}
                    className={lang === 'en' ? 'rotate-180' : 'rotate-0'}
                  />
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </MainLayout>
  )
}

export default StakingDashboard
export {
  useClickOutside,
  HintBox,
  useWindowSize,
  formatNumber,
  stringToNumber,
  deformatNumber,
  MobileModal,
  ModalLayout,
  getMainTheme,
  useMainContext,
  Text,
  MainLayout,
  useCopyToClipboard,
  CardLayout,
}
